import React, { useState, useEffect } from 'react';
import { Users, Edit2, PlusCircle, ArrowLeft, Trash2, ToggleLeft, ToggleRight, ArrowUpDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from './config';

function KullaniciYonetimi() {
    const [kullanicilar, setKullanicilar] = useState([]);
    const [firmalar, setFirmalar] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [formData, setFormData] = useState({
        firma_id: '',
        email: '',
        sifre: '',
        rol: 'Müşteri',
        Durum: 'Aktif'
    });

    useEffect(() => {
        fetchKullanicilar();
        fetchFirmalar();
    }, []);

    const fetchKullanicilar = async () => {
        const res = await api.get('/api/kullanicilar');
        setKullanicilar(res.data);
    };

    const fetchFirmalar = async () => {
        const res = await api.get('/api/firmalar');
        setFirmalar(res.data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.email || !formData.firma_id) return alert("Tüm alanları doldurun!");
        if (!editId && !formData.sifre) return alert("Şifre zorunludur!");

        try {
            if (editId) {
                await api.put(`/api/kullanicilar/${editId}`, formData);
                alert("Kullanıcı güncellendi!");
            } else {
                await api.post('/api/kullanicilar', formData);
                alert("Kullanıcı eklendi!");
            }
            resetForm();
            fetchKullanicilar();
        } catch (err) {
            console.error(err);
            alert("İşlem başarısız!");
        }
    };

    const resetForm = () => {
        setFormData({ firma_id: '', email: '', sifre: '', rol: 'Müşteri', Durum: 'Aktif' });
        setFormOpen(false);
        setEditId(null);
    };

    const handleEdit = (k) => {
        setEditId(k.kullanıcı_id);
        setFormData({
            firma_id: k.firma_id,
            email: k.email,
            sifre: '',
            rol: k.rol,
            Durum: k.Durum || 'Aktif'
        });
        setFormOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Bu kullanıcıyı silmek istediğinize emin misiniz?")) return;
        try {
            await api.delete(`/api/kullanicilar/${id}`);
            fetchKullanicilar();
        } catch { alert("Silme işlemi başarısız!"); }
    };

    const toggleDurum = async (k) => {
        const yeniDurum = k.Durum === 'Aktif' ? 'Pasif' : 'Aktif';
        try {
            await api.put(`/api/kullanicilar/${k.kullanıcı_id}`, {
                firma_id: k.firma_id,
                email: k.email,
                rol: k.rol,
                Durum: yeniDurum
            });
            fetchKullanicilar();
        } catch { alert("Durum değiştirilemedi!"); }
    };

    const getFirmaAdi = (firmaId) => {
        const firma = firmalar.find(f => f.firma_id === firmaId);
        return firma ? firma.firma_adı : '-';
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedKullanicilar = [...kullanicilar].sort((a, b) => {
        if (!sortConfig.key) return 0;
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        // Firma adına göre sıralama için özel durum
        if (sortConfig.key === 'firma_id') {
            aVal = getFirmaAdi(a.firma_id);
            bVal = getFirmaAdi(b.firma_id);
        }

        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';

        if (typeof aVal === 'string') aVal = aVal.toLowerCase();
        if (typeof bVal === 'string') bVal = bVal.toLowerCase();

        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const SortableHeader = ({ label, sortKey }) => (
        <th style={{ ...p12, cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort(sortKey)}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {label}
                <ArrowUpDown size={14} color={sortConfig.key === sortKey ? '#3b82f6' : '#9ca3af'} />
            </div>
        </th>
    );

    return (
        <div style={{ padding: '20px', backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

                <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '20px', color: '#3b82f6', textDecoration: 'none' }}>
                    <ArrowLeft size={18} /> Ana Sayfa
                </Link>

                <div style={panelStyle}>
                    <h2 style={{ marginTop: 0 }}><Users size={24} style={{ verticalAlign: 'middle', marginRight: '10px' }} /> Kullanıcı Yönetimi</h2>

                    <button onClick={() => { setFormOpen(!formOpen); if (formOpen) resetForm(); }} style={{ ...saveBtn, backgroundColor: '#8b5cf6', marginBottom: '20px' }}>
                        <PlusCircle size={18} style={{ marginRight: '8px' }} />
                        {formOpen ? "İptal" : "Yeni Kullanıcı Ekle"}
                    </button>

                    {formOpen && (
                        <form onSubmit={handleSubmit} style={{ marginBottom: '20px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '12px' }}>
                            <h4 style={{ marginTop: 0 }}>{editId ? "Kullanıcı Düzenle" : "Yeni Kullanıcı"}</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                                <div>
                                    <label style={labelStyle}>Firma</label>
                                    <select value={formData.firma_id} onChange={e => setFormData({ ...formData, firma_id: parseInt(e.target.value) })} style={inputBase} required>
                                        <option value="">Firma Seç...</option>
                                        {firmalar.map(f => <option key={f.firma_id} value={f.firma_id}>{f.firma_adı}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={labelStyle}>Email</label>
                                    <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} style={inputBase} required />
                                </div>
                                <div>
                                    <label style={labelStyle}>Şifre {editId && "(boş bırakılırsa değişmez)"}</label>
                                    <input type="password" value={formData.sifre} onChange={e => setFormData({ ...formData, sifre: e.target.value })} style={inputBase} {...(!editId && { required: true })} />
                                </div>
                                <div>
                                    <label style={labelStyle}>Rol</label>
                                    <select value={formData.rol} onChange={e => setFormData({ ...formData, rol: e.target.value })} style={inputBase}>
                                        <option value="Müşteri">Müşteri</option>
                                        <option value="User">User</option>
                                        <option value="Admin">Admin</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={labelStyle}>Durum</label>
                                    <select value={formData.Durum} onChange={e => setFormData({ ...formData, Durum: e.target.value })} style={inputBase}>
                                        <option value="Aktif">Aktif</option>
                                        <option value="Pasif">Pasif</option>
                                        <option value="Beklemede">Beklemede</option>
                                    </select>
                                </div>
                            </div>
                            <button type="submit" style={{ ...saveBtn, backgroundColor: editId ? '#f59e0b' : '#10b981', marginTop: '20px' }}>
                                {editId ? "Güncelle" : "Kaydet"}
                            </button>
                        </form>
                    )}

                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e5e7eb' }}>
                                    <SortableHeader label="ID" sortKey="kullanıcı_id" />
                                    <SortableHeader label="Email" sortKey="email" />
                                    <SortableHeader label="Firma" sortKey="firma_id" />
                                    <SortableHeader label="Rol" sortKey="rol" />
                                    <SortableHeader label="Durum" sortKey="Durum" />
                                    <th style={p12}>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedKullanicilar.map(k => (
                                    <tr key={k.kullanıcı_id} style={{ borderBottom: '1px solid #f3f4f6', opacity: k.Durum === 'Pasif' ? 0.5 : 1 }}>
                                        <td style={p12}>{k.kullanıcı_id}</td>
                                        <td style={p12}><strong>{k.email}</strong></td>
                                        <td style={p12}>{getFirmaAdi(k.firma_id)}</td>
                                        <td style={p12}>
                                            <span style={{
                                                padding: '4px 12px',
                                                borderRadius: '12px',
                                                backgroundColor: k.rol === 'Admin' ? '#fef3c7' : '#dbeafe',
                                                color: k.rol === 'Admin' ? '#92400e' : '#1e40af',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}>
                                                {k.rol}
                                            </span>
                                        </td>
                                        <td style={p12}>
                                            <button onClick={() => toggleDurum(k)} style={{ ...iconBtn, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                {k.Durum === 'Aktif' ? (
                                                    <><ToggleRight size={22} color="#10b981" /> <span style={{ color: '#10b981', fontSize: '12px' }}>Aktif</span></>
                                                ) : (
                                                    <><ToggleLeft size={22} color="#ef4444" /> <span style={{ color: '#ef4444', fontSize: '12px' }}>Pasif</span></>
                                                )}
                                            </button>
                                        </td>
                                        <td style={p12}>
                                            <button onClick={() => handleEdit(k)} style={iconBtn}><Edit2 size={18} color="#f59e0b" /></button>
                                            <button onClick={() => handleDelete(k.kullanıcı_id)} style={iconBtn}><Trash2 size={18} color="#ef4444" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '25px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const inputBase = { padding: '12px', borderRadius: '8px', border: '1px solid #ddd', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#374151' };
const saveBtn = { color: 'white', border: 'none', borderRadius: '8px', padding: '12px 20px', cursor: 'pointer', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' };
const iconBtn = { border: 'none', background: 'none', cursor: 'pointer', marginRight: '8px' };
const p12 = { padding: '12px' };

export default KullaniciYonetimi;
